import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { PainStory } from './components/PainStory';
import { WhyItFailed } from './components/WhyItFailed';
import { Mechanism } from './components/Mechanism';
import { Deliverables } from './components/Deliverables';
import { Audience } from './components/Audience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { Faq } from './components/Faq';
import { Offer } from './components/Offer';
import { StickyCta } from './components/StickyCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-white font-sans" data-id="element-0" data-mp="2wj8fnurpiy7c">
      <Hero data-id="element-1" data-mp="28ufm24yk52fw" />
      <main data-id="element-2" data-mp="28tw4wqgqei2x">
        <PainStory data-id="element-3" data-mp="28tmifcuwat1z" />
        <WhyItFailed data-id="element-4" data-mp="28suu8n3mnxlq" />
        <Mechanism data-id="element-5" data-mp="28sb9kymlev40" />
        <Deliverables data-id="element-6" data-mp="23vcikoy874a1" />
        <Audience data-id="element-7" data-mp="23w4gi6fape3h" />
        <HowItWorks data-id="element-8" data-mp="23ujjma5idj2g" />
        <Proof data-id="element-9" data-mp="23v2tr4ox335x" />
        <Faq data-id="element-10" data-mp="23ti7e2craqj5" />
        <Offer data-id="element-11" data-mp="3ik7gwiph6frp" />
      </main>
      <Footer data-id="element-12" data-mp="3iiwdijzxza14" />
      <StickyCta data-id="element-13" data-mp="3ij65gd4jrr9g" />
    </div>;
}